<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g5l6T6/tc-custom/9781488020018.jpg?1728327053808" alt="This image is the cover for the book Tangled Destinies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tangled Destinies
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times–</i>bestselling author, a man fights to protect the woman he once loved and left behind.</b><br/><br/> Saved from an abduction and unthinkable harm, Gabrielle Bennett owed her life to her rescuer. Marc Stephano, a stranger from the sketchy shadows of town, could’ve asked for money. Instead he introduced her to desire and claimed her completely—then he broke her heart.<br/><br/> Older, wiser and now a top New York model, Gabrielle is prepared for anything—except Marc’s reemergence into her life. It’s a merciless trick of fate. A successful, self-made millionaire, he’s as powerful as ever, but can Gabrielle forgive and forget—in the name of love?<br/><br/> “Palmer proves that love and passion can be found even in the most dangerous situations.” —<i>Publishers Weekly</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Palmer
      </h2>
      
      <p class="authorDescription body article">The prolific author of more than one hundred books, Diana Palmer got her start as a newspaper reporter. A New York Times bestselling author and voted one of the top ten romance writers in America, she has a gift for telling the most sensual tales with charm and humor. Diana lives with her family in Cornelia, Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1c300c6